
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { CTASection } from './components/CTASection';
import { BenefitsSection } from './components/BenefitsSection';
import { GallerySection } from './components/GallerySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProcessSection } from './components/ProcessSection';
import { MaterialsSection } from './components/MaterialsSection';
import { AreasSection } from './components/AreasSection';
import { ContactSection } from './components/ContactSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <CTASection />
        <BenefitsSection />
        <GallerySection />
        <TestimonialsSection />
        <ProcessSection />
        <MaterialsSection />
        <AreasSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
